import { Slide } from "@jelly/lesson";
import config from "appConfig";

const principle: Slide = {
  title: "Simulator",
  layout: {
    type: "simple",
    options: {
      components: [
        {
          variant: "layout",
          data: {
            type: "customCase030207",
            options: {
              imageWindOff: `${config.ASSETS_URL}/03/case-02/principle/7-wind-off.png`,
              imageWindOn: `${config.ASSETS_URL}/03/case-02/principle/7-wind-on.png`,
              soundMap: {
                "0,0,0": `${config.ASSETS_URL}/03/case-02/principle/05_Simulator_S1 EM Wind A Tire A.wav`,
                "0,1,1": `${config.ASSETS_URL}/03/case-02/principle/05_Simulator_S2 EM Wind B Tire B.wav`,
                "0,1,0": `${config.ASSETS_URL}/03/case-02/principle/05_Simulator_S3 EM Wind A Tire B.wav`,
                "0,0,1": `${config.ASSETS_URL}/03/case-02/principle/05_Simulator_S4 EM Wind B Tire A.wav`,
                "1,0,0": `${config.ASSETS_URL}/03/case-02/principle/05_Simulator_S5 ICE Wind A Tire A.wav`,
                "1,1,1": `${config.ASSETS_URL}/03/case-02/principle/05_Simulator_S6 ICE Wind B Tire B.wav`,
                "1,1,0": `${config.ASSETS_URL}/03/case-02/principle/05_Simulator_S7 ICE Wind A Tire B.wav`,
                "1,0,1": `${config.ASSETS_URL}/03/case-02/principle/05_Simulator_S8 ICE Wind B Tire A.wav`,
              },
            },
          },
        },
      ],
    },
  },
};

export default principle;
